export default {
  errors: {
    outOfStock: {
      title: {
        en: 'Some products are out of stock',
      },
      text: {
        en: 'Following items are out of stock: {outOfStockItems}.',
      },
    },
  },
}
